import type { UnifiedCardStack } from "@shared/models/card-stack"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import { useMemo } from "react"
import { Button } from "react-aria-components"
import UnifiedCardStackEditor from "./UnifiedCardStackEditor"

interface Props {
  cardStack: UnifiedCardStack & { attributes: { usedAs: "lesson-template" } }
  /** Distinguishes the wrapper styling between the surfaces a template is edited in. */
  className?: string
  /**
   * When provided, shows a "Delete Template" option that calls this on click.
   * Templates in the course-creation flow omit it.
   */
  onDelete?: () => void
}

export default function UnifiedTemplateEditor({ cardStack, className, onDelete }: Props) {
  // TODO: Fuller template chrome (e.g. title treatment) - like the legacy template editors.

  const modelsNeededForFirstEdit: ModelsNeededForFirstEdit = useMemo(
    () => ({ cardStack }),
    [cardStack],
  )

  return (
    <div className={className}>
      {/* Don't pass openStandardsModal or openGoogleClassroomSidebar - not supported for templates. */}
      <UnifiedCardStackEditor
        cardStack={cardStack}
        modelsNeededForFirstEdit={modelsNeededForFirstEdit}
        isNonInstructional={false}
      />
      {onDelete && (
        <Button
          className="test-delete-template mx-auto my-3 flex w-fit cursor-pointer flex-row items-center justify-center border border-transparent px-3 py-1.5 text-center align-middle text-sm leading-[1.42857] font-normal whitespace-nowrap text-red select-none hover:underline"
          onPress={onDelete}
        >
          Delete Template
        </Button>
      )}
    </div>
  )
}
